<template>
    <div>
     <Banner/>
     <BannerDetails/>
     <YoutubeSection/>
     <DonationGWF/>
     <SupportPartner/>
    </div>
</template>
<script>
import Banner from "./bannerSection";
import BannerDetails from "./gwfDetails.vue";
import YoutubeSection from "./youtubeSection.vue";
import DonationGWF from "./donationGwf.vue";
import SupportPartner from "./supportPartner.vue";  

export default {
    components:{
        Banner,
        BannerDetails,
        YoutubeSection,
        DonationGWF,
        SupportPartner
    }
    
}   
</script>